module.exports = __webpack_public_path__ + "static/img/online-account-registration.0aa499e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recent-works/online-account-registration.png
// module id = Hb0V
// module chunks = 1